// Shared constants + helpers for InspectionView. Lifted out during the
// 2026-05-01 split. No value changes.

import type { InspectionStatus, Room } from '@/api/inspections';

export const QUICK_ADD_ROOMS = [
  'Kitchen',
  'Living Room',
  'Master Bedroom',
  'Bedroom',
  'Bathroom',
  'Basement',
  'Crawlspace',
  'Attic',
  'Garage',
  'Exterior',
  'Roof',
];

export const STATUS_META: Record<InspectionStatus, { label: string; tone: 'success' | 'neutral' | 'info' }> = {
  pending_agreement: { label: 'Awaiting Agreement', tone: 'neutral' },
  in_progress:       { label: 'In Progress',        tone: 'info'    },
  completed:         { label: 'Completed',           tone: 'success' },
  archived:          { label: 'Archived',            tone: 'neutral' },
};

export function pendingComponentCount(room: Room): number {
  const comps = room.components ?? [];
  if (comps.length === 0) {
    // Legacy inspection: no components, treat all findings as captured.
    // "Pending" is meaningless here — return 0 so the tab stays quiet.
    return 0;
  }
  const findingsByComp = new Set(room.findings.map((f) => f.componentId).filter(Boolean));
  return comps.reduce((sum, c) => {
    const hasStatus = c.inspectionStatus !== null;
    const hasFindings = findingsByComp.has(c.id);
    return hasStatus || hasFindings ? sum : sum + 1;
  }, 0);
}
